import { getDeviceAndUserStore } from '../storage/stores';
import {
  SafeNetwork,
  SafeNetworksSettingsResponse,
} from '../types/api/safeNetworks';
import { getApi } from '.';
import {
  isArrayOf,
  isNumber,
  isObject,
  isString,
} from '../helper/typeChecking';

export const fetchSafeNetworksSettings =
  async (): Promise<SafeNetworksSettingsResponse> => {
    const deviceAndUser = getDeviceAndUserStore().get();
    if (!deviceAndUser) {
      throw new Error('Device and user store not initialized');
    }

    const { data }: { data: SafeNetworksSettingsResponse } =
      await getApi().safeNetworksSettings.get({
        deviceUId: deviceAndUser.device,
      });

    if (!isSafeNetworksSettingsResponse(data)) {
      throw new Error('Invalid Safe Networks settings');
    }

    return data;
  };

const isSafeNetwork = (safeNetwork: unknown): safeNetwork is SafeNetwork =>
  isObject<SafeNetwork>(safeNetwork) &&
  isString(safeNetwork.url) &&
  isNumber(safeNetwork.expected_status_code) &&
  isArrayOf(safeNetwork.expected_content_match, isObject);

const isSafeNetworksSettingsResponse = (
  response: unknown
): response is SafeNetworksSettingsResponse =>
  isObject<SafeNetworksSettingsResponse>(response) &&
  isArrayOf(response.networks, isSafeNetwork);
